define('evicommon/search/search.filter',['require','exports','module','underscore','backbone','./search.field'],function(require, exports, module){
  var _           = require('underscore');
  var Backbone    = require('backbone');
  var SearchField = require('./search.field');

  var SearchFilter = Backbone.Model.extend({

    set: function(key, val, options) {
      // normalize input
      var attrs;
      if (typeof key === 'object') {
       attrs = _.extend({}, key);
       options = val;
      } else {
       (attrs = {})[key] = val;
      }

      this.ensureFieldAttributeIsInitialize();

      if (this.isAttributesDefinedButNotAModel(attrs.field)) {
        this.setFieldModelAttributes(attrs.field);
        delete attrs.field;
      }

      return Backbone.Model.prototype.set.call(this, attrs, options);
    },

    isAttributesDefinedButNotAModel: function(attrs) {
      return attrs && !(attrs instanceof Backbone.Model);
    },

    ensureFieldAttributeIsInitialize: function() {
      if (!this.has('field')) {
        this.attributes.field = new SearchField();
      }
    },

    setFieldModelAttributes: function(attrs) {
      var fieldModel = this.get('field');
      if (_.isString(attrs)) {
        attrs = { name: attrs };
      }
      fieldModel.set(attrs);
    },

    displayName: function() {
      return this.field().get('displayName');
    },

    name: function() {
      return this.field().get('name');
    },

    field: function() {
      return this.get('field');
    },

    value: function() {
      if (arguments.length > 0) {
        this.set('value', arguments[0]);
        return this;
      }
      return this.get('value');
    },

    operation: function() {
      if (arguments.length > 0) {
        this.set('operation', arguments[0]);
        return this;
      }
      return this.get('operation');
    }

  });

  SearchFilter.Collection = Backbone.Collection.extend({

    model: SearchFilter,

    // DEPRECATED: just youse this.add({ field: 'fieldName' })
    addFilterWithField: function(attrs) {
      return this.add({ field: attrs });
    },

    setValueByName: function(name, value) {
      var filter = this.findByName(name);

      if (filter) {
        filter.set('value', value);
      }

      return this;
    },

    findByName: function(name) {
      name = String(name).toLowerCase();
      
      return this.find(function(filter) {
        return String(filter.name().toLowerCase()) === name;
      });
    }

  });

  module.exports = SearchFilter;
});
